module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABE0lEQVQokWNgwAHKysp4s/ILz2YVFEeD+FkFRQnZBUVJ2QWlRrj0oGs+BtRUnZVX9BxkSGZe0ezs/OJ5mXmF/xsaGlgIa84vnA7i5xQXawDZLzLzi2LALskv+j1z5kxWojTDQH5+mTrIJSBDgAbMWrVqFTPRmrEZQrJmvIYAA4SNGM04DcnLK1UlVjO6If///2dkyCwo8QYJAgXuEaMZmBaygRYWgwxBiU5Q/IJNBLHzS/RAfKChD8A4v/A8TA6UNjLzC1sxTEY2AKipFshfVFBQoQDCyImHeAPyi5uR5P7QxwBgKouD4OKpaAb8z84rjofKT8ZqAFBTIcjfIJyVV7ipsLBQCC6XV5yPLJddWSkMkwMARhraugpl9VgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-home_1x.png
// module id = 2286
// module chunks = 0